import React, { useEffect, useState } from "react";

const ImpersonationBanner = () => {
  const [isImpersonating, setIsImpersonating] = useState(false);

  useEffect(() => {
    const impersonating = localStorage.getItem("is_impersonating");
    setIsImpersonating(impersonating === "true");
  }, []);

  const handleExitImpersonation = () => {
    const originalSession = localStorage.getItem("superadmin_original_session");

    if (originalSession) {
      // Restore original session
      localStorage.setItem("accesstoken", originalSession);
      localStorage.removeItem("superadmin_original_session");
      localStorage.removeItem("is_impersonating");

      // Redirect to superadmin dashboard
      window.location.href = "/superadmin";
    }
  };

  if (!isImpersonating) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-yellow-500 text-black px-4 py-2 flex justify-between items-center shadow-lg">
      <div className="flex items-center gap-2">
        <i className="fa-solid fa-user-secret"></i>
        <span className="font-semibold">
          You are currently impersonating a user
        </span>
      </div>
      <button
        onClick={handleExitImpersonation}
        className="px-4 py-1 bg-black text-yellow-500 rounded hover:bg-gray-800 font-semibold"
      >
        Exit Impersonation
      </button>
    </div>
  );
};

export default ImpersonationBanner;
